import { TPermissionsCatalog, TRole } from "@/models/roles.model";
import axios from "@utils/axios-instance";

export const getAll = async (): Promise<TRole[]> => {
  const response = await axios.get("/roles");
  return response.data;
};

export const save = async (data: TRole): Promise<TRole> => {
  const { name, permissions } = data;
  const permissionsIds = permissions.map((i) => i.id);

  const response = await axios.post("/roles", { name, permissions: permissionsIds });
  return response.data;
};

export const removeById = async (roleId: number): Promise<void> => {
  await axios.delete(`/roles/${roleId}`);
};

export const update = async (role: TRole): Promise<void> => {
  const { id: roleId, name, permissions, isSystemAdmin } = role;
  // The auto-created system admin role has locked permissions; only its name
  // is editable, so skip the `permissions` field in the payload entirely.
  const payload: { name: string; permissions?: number[] } = { name };
  if (!isSystemAdmin) {
    payload.permissions = permissions.map((p) => p.id);
  }
  await axios.patch(`/roles/${roleId}`, payload);
};

export const getPermissionsCatalog = async (): Promise<TPermissionsCatalog> => {
  const response = await axios.get("/permissions/catalog");
  return response.data;
};

export const assignUsers = async (roleId: number, userIds: number[]): Promise<void> => {
  await axios.put(`/roles/${roleId}/users`, { userIds });
};

export default {
  getAll,
  save,
  removeById,
  update,
  getPermissionsCatalog,
  assignUsers,
};
